module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: _vm.getNavClassName()
  }, [_c('router-link', {
    staticClass: "pagination-previous",
    attrs: {
      "to": _vm.urlBuilder(_vm.prevPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage - 1)
    }
  }, [_vm._v(_vm._s(_vm.prev))]), _vm._v(" "), _c('router-link', {
    staticClass: "pagination-next",
    attrs: {
      "to": _vm.urlBuilder(_vm.nextPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage + 1)
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, _vm._l((_vm.pagingList), function(item) {
    return _c('li', [(item !== '...') ? _c('router-link', {
      class: _vm.getPagingClassName(item),
      attrs: {
        "to": _vm.urlBuilder(item)
      }
    }, [_vm._v(_vm._s(item))]) : _c('span', {
      staticClass: "pagination-ellipsis"
    }, [_vm._v("...")])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e03decb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-pagination/src/Pagination.vue
// module id = 352
// module chunks = 1